module.exports = __webpack_public_path__ + "static/img/about6.38ddcd8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/about6.jpg
// module id = DNaR
// module chunks = 0